module.exports = __webpack_public_path__ + "img/resort-01.d9a7c2e6.jpg";